/**
 * Écran Profils (overlay 100 % local, même pattern que Réglages/À propos).
 * Rendu pur : reflète le registre de `profile.ts`. Les clics sont câblés dans `main.ts`.
 * Un profil = prénom/surnom + avatar, stocké uniquement sur l'appareil. L'invité
 * (aucun profil) reste toujours proposé en premier.
 */
import { AVATARS, activeProfileId, listProfiles, profilePts } from '../../profile';

const $ = (id: string): HTMLElement | null => document.getElementById(id);

/** État transitoire de la création (hors stockage) : avatar sélectionné. */
let pickedAvatar: string = AVATARS[0];

export function pickedAvatarValue(): string {
  return pickedAvatar;
}
export function setPickedAvatar(a: string): void {
  pickedAvatar = a;
  renderAvatarGrid();
}

function ptsLabel(n: number): string {
  return `🏆 ${n} pt${n > 1 ? 's' : ''}`;
}

/** Une carte de profil (ou invité). `pid` vide = invité. */
function card(pid: string, avatar: string, name: string, sub: string, active: boolean): string {
  const del = pid
    ? `<button class="profDel" data-del="${pid}" aria-label="Supprimer ${name}">🗑</button>`
    : '';
  return `<div class="profCard${active ? ' active' : ''}" data-pid="${pid}" role="button" tabindex="0" aria-label="Profil ${name}${active ? ' (actif)' : ''}">
    <span class="profAv">${avatar}</span>
    <span class="profMeta"><b class="profNm">${name}</b><span class="profSub">${sub}</span></span>
    ${active ? '<span class="profOn" aria-hidden="true">✓</span>' : ''}
    ${del}
  </div>`;
}

export function renderProfile(): void {
  const list = $('profList');
  if (!list) return;
  const active = activeProfileId();
  let html = card('', '👤', 'Invité', `Sans profil · ${ptsLabel(profilePts(null))}`, active === null);
  for (const p of listProfiles()) {
    html += card(p.id, p.avatar, p.name, ptsLabel(profilePts(p.id)), active === p.id);
  }
  html += `<button class="profCard add" id="profNewCard" aria-label="Nouveau profil">
    <span class="profAv">➕</span>
    <span class="profMeta"><b class="profNm">Nouveau profil</b><span class="profSub">Garde ta progression à part</span></span>
  </button>`;
  list.innerHTML = html;
}

/** Grille d'avatars du formulaire de création (sélection reflétée). */
export function renderAvatarGrid(): void {
  const grid = $('avatarGrid');
  if (!grid) return;
  grid.innerHTML = AVATARS.map(
    (a) =>
      `<button class="avOpt${a === pickedAvatar ? ' on' : ''}" data-av="${a}" aria-label="Avatar ${a}" aria-pressed="${a === pickedAvatar}">${a}</button>`,
  ).join('');
}
